import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axiosInstance from "../../interceptor/axiosInstance";
import { Link, useNavigate } from "react-router-dom";
import NotificationService from "../Utils/NotificationService";
import "../Registration/Register.css";

const ForgotPassword = () => {
  const [emailError, setEmailError] = useState(""); // State for error message
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      emailId: ""
    },
    validationSchema: Yup.object({
      emailId: Yup.string()
        .email("Invalid email address")
        .required("Email is required")
    }),

    onSubmit: async (payload, { resetForm }) => {
      setEmailError(""); // Clear previous errors
      try {
        const response = await axiosInstance.post(`/auth/forgot-password`, payload);
        if (response?.data?.error === "EMAIL_NOT_FOUND") {
          setEmailError("Email ID does not exist.");
        } else {
        // Simulating success response
        resetForm();
        NotificationService.success("Password reset instructions sent to your email!");
        }
      } catch (err) {
        if (err.response && err.response.data && err.response.data.error) {
          if (err.response.data.error === "EMAIL_NOT_FOUND") {
            setEmailError("Email ID does not exist.");
          } else {
            NotificationService.error("An error occurred. Please try again.");
          }
        } else {
          NotificationService.error("An error occurred. Please try again.");
        }
      }
    },
  });

  return (
    <div className="auth-page">
      {/* Background Orbs */}
      <div className="bg-orbs">
        <div className="orb-1"></div>
        <div className="orb-2"></div>
      </div>

      <div className="auth-card">
        <Link to="/">
          <img src="/ezzDesk_Logo.svg" alt="EzzDesk Logo" className="auth-logo" />
        </Link>
        <h1 className="auth-title" style={{marginBottom: '10px'}}>Forgot password?</h1>
        <p style={{color: '#475569', marginBottom: '30px', fontSize: '15px'}}>
          Enter your Email to help us identify you.
        </p>

        <form onSubmit={formik.handleSubmit} className="auth-form" noValidate>
          {emailError && (
            <div style={{ color: "#e11d48", fontSize: "14px", marginTop: "-10px", marginBottom: "5px" }}>
              {emailError}
            </div>
          )}
          
          <div>
            <input
              id="emailId"
              name="emailId"
              type="email"
              placeholder="Enter Email Id"
              className="auth-input"
              value={formik.values.emailId}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.emailId && formik.errors.emailId && (
              <span className="text-danger">{formik.errors.emailId}</span>
            )}
          </div>

          <button type="submit" className="auth-button">
            Resend Password
          </button>
        </form>

        <div className="auth-footer">
          <p><Link to="/login" className="auth-link">Return to Sign In</Link></p>
          <p style={{marginTop: '10px'}}><Link to="/register" className="auth-link">Don't have an account?</Link></p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
